<template>
  <div class="container">
    <!-- 滑动文字区域 -->
    <div class="scrollable-text">
      <p>
        每周领取3次使用次数，每周日晚上12点刷新领取机会。<br>
感谢您的陪伴与信任。 
      </p>
    </div>

    <!-- 固定按钮 -->
    <button class="fixed-button" @click="receive">领取</button>
  </div>
</template>

<script>
import axios from 'axios'
import { ElMessage } from 'element-plus';
const baseURLA = (() => {
  const { hostname, protocol } = window.location;
  console.log(hostname)
  console.log(protocol)
  return '/api'; 
})();
axios.defaults.baseURL = baseURLA
// axios.defaults.baseURL = process.env.VUE_APP_URL

export default {
  created() {
    document.title = '领取次数';


    if (this.judgeClient() === "Android") {
      this.getAT()
    } else {
      this.getTokenFromWebView()

      window.addEventListener("IosFound", this.handleMessage);

      window.handleMessage = this.handleMessage;
    }




  },
  deactivated() {
    // 在组件销毁时移除事件监听器，以防止内存泄漏
    window.removeEventListener("IosFound", this.handleMessage);
  },
  data() {
    return {
      token: null
    };
  },
  name: 'ReceiveTimes',
  props: {
    msg: String
  },
  methods: {
    getTokenFromWebView() {
      if (window.webkit && window.webkit.messageHandlers) {

        // 在 Vue 中调用 iOS WebView 的 getToken 方法
        window.webkit.messageHandlers.IosFound.postMessage("getToken");


      } else {
        ElMessage.error("window.webkit is not defined or missing messageHandlers");
      }
    },

    getAT() {
      this.token = window.android.getToken("")
      // ElMessage.success(this.token)
    },
    handleMessage(event) {
      // 处理从 WebView 接收到的消息

      // ElMessage.success(event.data.token);
      this.token = event.data.token

      // 根据你的实际需求进行处理，例如更新组件状态等
    },
    // 检查客户端
    judgeClient() {
      let u = navigator.userAgent;
    
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);     //判断是否是 iOS终端
      console.log('是否是Android：' + isAndroid); //true,false
      console.log('是否是iOS：' + isIOS);
      if (isAndroid) {
        return 'Android';
      } else if (isIOS) {
        return 'IOS';
      } else {
        return 'PC';
      }
    },

    async receive() {
      try {

        const res = await axios.post('/activity/center/receive/number', {

        }, {
          headers: {

            'Content-Type': 'application/json', // 设置请求头部
            'Token': this.token,
            // 'Token': "8648e1b8623643608f468bfb46325fd1.9bc1f1a0cb4f497e12d531c6918ecd7f",
            'Channel': 'Web',
            'Platform': 'Web',
            'Device-Info': 'Web',
            'App-Version-Code': '1.0.0',
            'App-Version-Name': '1',
          }
        })

        if (res.data.code === 200) {
          ElMessage.success(res.data.msg); // 成功提示
          
        } else {
          ElMessage.warning(res.data.msg); // 错误提示
        }
        // this.responseData = JSON.stringify(res.data.data)

      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.scrollable-text {
  flex-grow: 1;
  overflow-y: auto;
  padding: 20px;
}

.scrollable-text p {
  text-align: left;
  /* 将文本左对齐 */
  margin: 0;
  /* 移除默认的段落边距 */
}

.fixed-button {
  width: 90%;
  height: 50px;
  background-color: #ff4500;
  /* 橙红色 */
  color: #fff;
  margin-bottom: 20px;
  border: none;
  border-radius: 25px;
  /* 圆角50 */
  font-size: 16px;
  cursor: pointer;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
</style>
